import { useMemo } from "react";
import { useAttributes } from "@/features/auth/hooks/useAttributes";

export const useUserEventFilters = (): string[] => {
  const attributes = useAttributes();
  const eventFilters = attributes?.eventFilters;

  return useMemo(() => {
    return eventFilters || [];
  }, [eventFilters]);
};
